import styled, { css } from "styled-components";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;

  border-radius: 6px;
  background-color: ${COLORS.WHITE};

  max-height: 100%;
  height: auto;

  ${({ withShadow }: { withShadow: boolean }) =>
    withShadow &&
    css`
      box-shadow: 0 16px 24px -8px rgba(0, 26, 216, 0.06);
    `}
`;
